function initProductCards(parent = document) {
  const addButtons = parent.querySelectorAll("[data-add-to-cart]");

  addButtons.forEach((button) => {
    if (button.dataset.cardBound === "true") return;
    button.dataset.cardBound = "true";

    button.addEventListener("click", async () => {
      const variantId = Number(button.dataset.variantId);
      if (!variantId) return;
      await addVariantToCart(variantId, button);
    });
  });
}

window.initProductCards = initProductCards;

document.addEventListener("DOMContentLoaded", () => {
  initProductCards();
});

async function addVariantToCart(variantId, button) {
  if (button.disabled || button.classList.contains("loading")) return;

  const originalContent = button.innerHTML;
  button.disabled = true;
  button.classList.add("loading");
  button.innerHTML = `${originalContent}<span class="loading__spinner"><span class="loading-spinner"></span></span>`;

  try {
    const response = await fetch(`${window.routes.cart_add_url}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || "Failed to add item");
    }

    publish(PUB_SUB_EVENTS.cartUpdate, {
      action: "add",
      variant: data,
      formData: { id: variantId, quantity: 1 },
    });
  } catch (error) {
    publish(PUB_SUB_EVENTS.cartError, { error: error.message });
  } finally {
    button.disabled = false;
    button.classList.remove("loading");
    button.innerHTML = originalContent;
  }
}
